<section class="w-100 float-left expert_section">
    <div class="container">
        <div class="row">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom">
                <h1 class="expert_text">
                    Let’s discuss your app idea and implement the innovative mobility solution for your business needs.
                </h1>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12 d-flex align-items-center justify-content-lg-start justify-content-center" data-aos="fade-up" data-aos-anchor-placement="bottom-bottom">
                <button class="main_btn text-uppercase" routerLink="/contact-us">Talk To Our Experts</button>
            </div>
        </div>
    </div>
  </section>